'use client';

import { HomePage, HomePageItem, HomePageItemType } from '@/models/HomePage';

// Above-the-fold components - Bundle ile birlikte yüklensin (dynamic import YOK)
import BannerlistWithProduct from './BannerlistWithProduct';
import ProductListSection from './ProductListSection';
import BannerlistWithCategoryList from './BannerlistWithCategoryList';
import BannerlistWithBanner from './BannerlistWithBanner';

// Below-the-fold components - Dynamic import ile lazy load
const SeoView = dynamic(() => import('./seo/SeoView').then((mod) => mod.SeoView), { ssr: false });

import Image from 'next/image';
import Link from 'next/link';
import { WebLink } from '@/lib/WebLinks';
import dynamic from 'next/dynamic';
import SmartImage from './SmartImage';
import { useEffect, useState } from 'react';
import { PriceData, PriceDataContainer } from '@/models/Product';
import { Endpoints } from '@/lib/Endpoints';
import { fetcher } from '@/lib/Requester';
import { HTTP_REQUEST } from '@/lib/Constants';

import { useEffect as _ue } from 'react';

export default function HomepageItem({
  item,
  index,
  isFirstItem,
  pricesData,
}: {
  item: HomePageItem;
  index: number;
  isFirstItem: boolean;
  pricesData: PriceData | null;
}) {
  switch (item.type) {
    case HomePageItemType.BANNERLIST_BANNER:
      return (
        <BannerlistWithBanner
          banner={item.banner}
          banners={item.banners}
          dir="ltr"
          key={index}
          isPriority={isFirstItem} // LCP optimizasyonu
        />
      );
    case HomePageItemType.BANNER_BANNERLIST:
      return (
        <BannerlistWithBanner
          banner={item.banner}
          banners={item.banners}
          dir="rtl"
          key={index}
          isPriority={isFirstItem} // LCP optimizasyonu
        />
      );
    case HomePageItemType.BANNERLIST_PRODUCT:
      return (
        <BannerlistWithProduct
          banners={item.banners}
          product={item.product}
          dir="ltr"
          key={index}
          isPriority={isFirstItem} // LCP optimizasyonu
        />
      );
    case HomePageItemType.PRODUCT_BANNERLIST:
      return (
        <BannerlistWithProduct
          banners={item.banners}
          product={item.product}
          dir="rtl"
          key={index}
          isPriority={isFirstItem} // LCP optimizasyonu
        />
      );
    case HomePageItemType.CATEGORY:
      return (
        <ProductListSection
          products={item.products}
          category={
            item.category ||
            (item.categories?.[0]
              ? {
                  id: item.categories[0].id,
                  title: item.categories[0].title,
                  imageUrl: item.categories[0].iconUrl,
                  url: item.categories[0].url,
                }
              : undefined)
          }
          title={item.title ?? ''}
          url={item.url ?? ''}
          showMore={true}
          key={index}
          showTitle={item.showCategoryTitle === 1}
          enableSwiper={false} // Performance için swiper disabled
          preventPriceFetch={true}
          fetchedPricesData={pricesData}
        />
      );
    case HomePageItemType.BANNERLIST_CATEGORYLIST:
      return (
        <BannerlistWithCategoryList
          banners={item.banners}
          categories={item.categories}
          categoriesTitle={item.categoriesTitle || ''}
          dir="ltr"
          key={index}
          isPriority={isFirstItem} // ANA SORUN ÇÖZÜMÜ!
        />
      );
    case HomePageItemType.CATEGORYLIST_BANNERLIST:
      return (
        <BannerlistWithCategoryList
          banners={item.banners}
          categories={item.categories}
          categoriesTitle={item.categoriesTitle || ''}
          dir="rtl"
          key={index}
          isPriority={isFirstItem} // LCP optimizasyonu
        />
      );
    case HomePageItemType.BANNER_UNDER_CONTENT:
      return null;
    default:
      return <></>;
  }
}
